import api from "./api";
import { NotificationList, ProcessStatusLimit } from "../models/Notification";

export const getMyNotifications = async (): Promise<NotificationList> =>
  (await api.get("/api/notification")).data;

export const markNotificationRead = async (id: string) =>
  api.put(`/api/notification/${id}/read`);

export const markAllNotificationsRead = async () =>
  api.put("/api/notification/read-all");

export const getStatusLimits = async (): Promise<ProcessStatusLimit[]> =>
  (await api.get("/api/notification/status-limits")).data;

export const saveStatusLimits = async (limits: ProcessStatusLimit[]) =>
  (await api.put("/api/notification/status-limits", limits)).data as {
    success: boolean;
    notifications?: string[];
  };
